<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->

<ptl-v3-dialog-shell
  [title]="'translations.membersNew.controlPanel.alumniUpload.title' | transloco"
  [description]="'translations.membersNew.controlPanel.alumniUpload.description' | transloco"
  [closeDisabled]="isLoading()"
  (closed)="closeDialog()"
>
  <div class="csv-upload__field">
    <span class="csv-upload__label">{{ 'translations.membersNew.controlPanel.alumniUpload.csvFile' | transloco }}</span>

    <div class="csv-upload__dropzone" [class.csv-upload__dropzone--error]="!!csvErrorKey()">
      <ptl-upload-file-area
        [accept]="acceptedFileTypes"
        [linkText]="'translations.global.ariaLabels.dragFileOrBrowse' | transloco"
        [hintText]="'translations.fileDropzone.allowedFormats' | transloco: { types: acceptedFileTypes }"
        (fileSelected)="onFileSelected($event)"
        (filesRejected)="onFilesRejected($event)"
      ></ptl-upload-file-area>
    </div>

    @if (csvErrorKey(); as errorKey) {
      <p class="csv-upload__error" role="alert">{{ errorKey | transloco }}</p>
    }

    @if (csvFile(); as file) {
      <div class="csv-upload__file">
        <ptl-icon [icon]="LucideFileSpreadsheet" size="s"></ptl-icon>
        <span class="csv-upload__file-name">{{ file.name }}</span>
        <button
          class="csv-upload__file-remove"
          type="button"
          [attr.aria-label]="('translations.global.label.remove' | transloco) + ' ' + file.name"
          (click)="removeSelectedFile()"
        >
          <ptl-icon [icon]="LucideX" size="xs"></ptl-icon>
        </button>
      </div>
    }

    <p class="csv-upload__template" [innerHTML]="'translations.members.alumni.description.csvDownload' | transloco | safeHtml"></p>
  </div>

  <div class="csv-upload__field">
    <span class="csv-upload__label">{{ 'translations.membersNew.controlPanel.alumniUpload.group' | transloco }}</span>

    <div class="csv-upload__group" [class.csv-upload__group--error]="groupInvalid()">
      <ptl-autocomplete-search
        [serverSide]="true"
        [options]="groupOptions()"
        [isLoading]="loadingGroups()"
        [ngModel]="selectedGroupUid()"
        [addLabel]="'translations.reviews.label.searchForGroups' | transloco"
        [searchPlaceholder]="'translations.reviews.label.searchForGroups' | transloco"
        [searchAriaLabel]="'translations.global.ariaLabels.searchForGroups' | transloco"
        [removeLabel]="'translations.global.label.remove' | transloco"
        (opened)="onGroupPanelOpened()"
        (searchTermChange)="onGroupSearchTermChange($event)"
        (selectionChange)="onGroupSelectionChange($event)"
      ></ptl-autocomplete-search>
    </div>

    @if (groupInvalid()) {
      <p class="csv-upload__error" role="alert">
        {{ 'translations.membersNew.controlPanel.alumniUpload.error.groupRequired' | transloco }}
      </p>
    }
  </div>

  <ng-container dialogFooter>
    <ptl-button
      type="secondary-neutral"
      size="m"
      [disabled]="isLoading()"
      [text]="'translations.global.button.cancel' | transloco"
      (clicked)="closeDialog()"
    ></ptl-button>
    <ptl-button
      type="primary"
      size="m"
      [disabled]="isLoading()"
      [loading]="isLoading()"
      [text]="'translations.global.button.upload' | transloco"
      (clicked)="uploadAlumniUsers()"
    ></ptl-button>
  </ng-container>
</ptl-v3-dialog-shell>
